export default __webpack_public_path__ + "static/media/ProximaNova-Regular.a34544d7.woff2";